import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "@arelia-components/layout/Header";
import { PATHS } from "../../routes";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import { ConnectionName } from "@arelia-types/connection";
import Content from "@arelia-components/layout/Content";
import { useConfiguration } from "src/api/configuration";

export default function Social() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data: configuration } = useConfiguration();
  
  const enablePosting = configuration?.flags?.EnablePosting === true;

  const navOptions = [
    { value: PATHS.SOCIAL + "/dashboard", label: "Dashboard" },
    { value: PATHS.SOCIAL + "/my-videos", label: "My Videos" },
    ...(enablePosting ? [{ value: PATHS.SOCIAL + "/create-a-post", label: "Create a post" }] : [])
  ];

  useEffect(() => {
    if (pathname === PATHS.SOCIAL) {
      navigate(PATHS.SOCIAL + "/dashboard");
    }
  }, [pathname]);

  return (
    <ContentBox>
      <Header
        title="My Social"
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      <Content requiredConnectionNames={[ConnectionName.facebook, ConnectionName.instagram, ConnectionName.youtube, ConnectionName.tiktok]} />
    </ContentBox>
  );
}
